export default function splideInit() {
  window.splideImg = new Splide('.splide-img', {
    type: 'loop',
    arrows: false,
    pagination: true,
    direction: 'ttb',
    height: 300,
    width: 300,
    interval: 2000,
    speed: 600,
    resetProgress: true,
    autoWidth: true,
    perPage: 1,
    drag: false,
    mediaQuery: 'min',
    breakpoints: {
      992: {
        width: 300,
        height: 300,
      },
      1440: {
        width: 511,
        height: 511,
      },
    },
  });
  window.splideWord = new Splide('.splide-word', {
    type: 'loop',
    arrows: false,
    pagination: true,
    direction: 'ttb',
    interval: 1000,
    height: 100,
    speed: 600,
    resetProgress: true,
    autoWidth: true,
    perPage: 1,
    drag: false,
    width: 340,
    mediaQuery: 'min',
    breakpoints: {
      992: {
        width: 340,
        height: 130,
      },
      1440: {
        width: 340,
        height: 130,
      },
    },
  });
}
